import {
  defSimpleUnit,
  defAlias,
  defBaseUnit,
  defInvertedUnit,
} from '../registry';

// These are weird units that are only useful as a component of
// another unit.  I suspect the Lscript lexer would choke on them
// if they were used as a standalone unit.
//
// These used to be used in the definitions of the below textile units.
// TODO: Check if anyone is directly using these units and delete if not.
defSimpleUnit('10km', 'meter', 10000);
defSimpleUnit('9000m', 'meter', 9000);

export const textileUnits = [
  defBaseUnit('tex'),
  defSimpleUnit('denier', 'tex', 1 / 9),
  defSimpleUnit('decitex', 'tex', 1 / 10),
  defInvertedUnit('number_metric', { tex: -1 }, 'tex', 1000),
  defSimpleUnit('number_english', 'number_metric', 0.5905403467794645),
];

defAlias('dtex', 'decitex');
